export default __webpack_public_path__ + "static/media/healtea3.0bf2f578.jpg";